/**
 * Guest_Service.ts
 * Guest identity = sk-CRM contacts (deduped by phone), reached via the adapter's
 * /v1/guests/* endpoints. Used by the shared GuestPicker in Reservations & Support.
 */

import { apiClient } from '../../api/axiosInstance';
import {
  Hosp_Guests_Url,
  Hosp_Guests_FindOrCreate_Url,
  Hosp_Guests_Batch_Url,
} from '../../api/endpoints';

export interface Guest {
  id: string;      // CRM contact id (ctc_…)
  name: string;
  phone?: string;
  email?: string;
}

/** Type-ahead search for the picker. */
export const searchGuests = async (q: string): Promise<Guest[]> => {
  if (!q || q.trim().length < 2) return []; // CRM requires a non-trivial query
  const { data } = await apiClient.get<Guest[]>(Hosp_Guests_Url, { params: { q: q.trim() } });
  return data;
};

/** Find-or-create by phone (CRM dedups). Requires a phone. */
export const findOrCreateGuest = async (input: { name: string; phone: string; email?: string }): Promise<Guest> => {
  const { data } = await apiClient.post<Guest>(Hosp_Guests_FindOrCreate_Url, input);
  return data;
};

/** Resolve many contact ids → guests in one call (for list rendering). */
export const getGuestsBatch = async (ids: string[]): Promise<Record<string, Guest>> => {
  const unique = [...new Set(ids.filter(Boolean))];
  if (unique.length === 0) return {};
  const { data } = await apiClient.get<Record<string, Guest>>(Hosp_Guests_Batch_Url, {
    params: { ids: unique.join(',') },
  });
  return data;
};
